import { render, staticRenderFns } from "./modalAddGiveawayPopup.vue?vue&type=template&id=38f94b7e&scoped=true&"
import script from "./modalAddGiveawayPopup.vue?vue&type=script&lang=js&"
export * from "./modalAddGiveawayPopup.vue?vue&type=script&lang=js&"
import style0 from "./modalAddGiveawayPopup.vue?vue&type=style&index=0&id=38f94b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f94b7e",
  null
  
)

export default component.exports